import api from '../../../api/_patient'

export default {
    getInfoPersonneAPrevenir(patient_id) {
        return new Promise((resolve, reject) => {
            api.getInfoPersonneAPrevenir(patient_id).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}